import { WorkflowJobStatus } from './enums';

/**
 * Set of statuses that indicate a workflow job has finished processing
 */
export const FINISHED_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.Skipped,
  WorkflowJobStatus.Success,
  WorkflowJobStatus.Error,
]);
